import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f3aa891"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = { style: {"font-size":"92%"} }
const _hoisted_3 = { style: {"font-weight":"500"} }
const _hoisted_4 = {
  style: {"font-size":"92%"},
  class: "mt-2"
}
const _hoisted_5 = { style: {"font-weight":"500"} }

import { useI18n } from "vue-i18n"
import { computed, onMounted, onUnmounted, ref } from "vue"
import { Hospital, HospitalDoctor } from "@/types"
import {
  departmentValueToDeMap,
  departmentValueToEnMap,
} from "@/types/hospital-spec"


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalDoctorInfo',
  props: {
    hospital: {}
  },
  setup(__props: any) {

const { t } = useI18n()

const props = __props
const hospital = ref<Hospital | undefined>(props.hospital)
const key = ref(0)
const doctors = computed((): HospitalDoctor[] => {
  var doctors: HospitalDoctor[] = []

  hospital.value?.doctors.forEach((d) => {
    doctors.push(d)
  })
  return doctors
})

const loadPage = () => {
  key.value++
}

onMounted(() => {
  window.addEventListener("locale-changed", loadPage)
})
onUnmounted(() => {
  window.removeEventListener("locale-changed", loadPage)
})

const doctorDepartment = (value: string): string => {
  return localStorage.getItem("locale") == "de"
    ? departmentValueToDeMap[value as string]
    : departmentValueToEnMap[value as string]
}

const doctorName = (d: HospitalDoctor) => {
  return d.title + " " + d.firstName + " " + d.lastName
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", { key: key.value }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctors.value, (doctor, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_component_v_card, _mergeProps({
          class: "mx-auto my-5 ml-3 mr-3",
          "max-width": "55%",
          height: "130"
        }, props, {
          onClick: ($event: any) => (_ctx.$router.push(`/doctors/${doctor.doctorId}`))
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "7",
                  align: "start"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("name")) + ":", 1),
                      _createElementVNode("p", _hoisted_3, _toDisplayString(doctorName(doctor)), 1),
                      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("hospital.department")) + ": ", 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(doctorDepartment(doctor.department) ?? "-"), 1)
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, { cols: "5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      class: "mt-2",
                      src: doctor.photo,
                      width: "100",
                      style: {"border-radius":"50%","cursor":"pointer"}
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["onClick"])
      ]))
    }), 128))
  ]))
}
}

})